module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-3-img-sp_4ceac5173b06d48182b9a7c722d818c3.png";